module.exports = __webpack_public_path__ + "img/excel-2x.b8ad81ee.png";